import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2rem;
  color: white;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;

  h1, h2 {
    color: white;
    margin: 1.5em 0 1em;
  }

  h1 {
    font-size: 2.5em;
    margin-top: 0;
  }

  h2 {
    font-size: 1.8em;
  }

  p {
    margin: 1em 0;
  }

  a {
    color: #FFD700;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  ul, ol {
    margin: 1em 0;
    padding-left: 2em;
  }

  hr {
    border: none;
    border-top: 1px solid #333;
    margin: 2em 0;
  }

  strong {
    color: #FFD700;
  }
`;

const Terms = () => {
  return (
    <Container>
      <h1>BusyBee – Terms and Conditions</h1>
      <p><strong>Last Updated:</strong> Friday 27th December 2024</p>

      <p>Welcome to BusyBee ("the App"), operated by <strong>Little Apps Ltd</strong> ("we," "us," or "our"). BusyBee is a productivity and task management application that integrates with Apple's EventKit to turn Apple Calendar events into live activities on users' device lock screens. By downloading, installing, accessing, or using BusyBee, you agree to be bound by the following Terms and Conditions ("T&Cs"). If you do not agree, please do not use the App.</p>

      <h2>1. Acceptance of Terms</h2>
      <p>1.1 By accessing or using BusyBee, you acknowledge that you have read, understood, and agree to be legally bound by these T&Cs, as well as any additional guidelines, policies, or rules posted in relation to the App.</p>
      <p>1.2 If you are using the App on behalf of an organization, you represent and warrant that you have the authority to bind that organization to these T&Cs.</p>

      <h2>2. Eligibility</h2>
      <p>2.1 There is no specific minimum age requirement for using BusyBee. However, if you are a minor under the laws of your jurisdiction, please ensure that your parent or legal guardian supervises your use of BusyBee.</p>

      <h2>3. Description of the Service</h2>
      <p><strong>3.1 BusyBee Features</strong><br />
      BusyBee helps users manage their schedules by integrating with Apple's EventKit. It retrieves event information from the user's Apple Calendar and displays live activities on the device lock screen. BusyBee does not store or retain this event information beyond what is necessary for the real-time display and scheduled updates.</p>

      <h2>4. Privacy and Data</h2>
      <p><strong>4.1 No Personal Information Collection</strong><br />
      We do not collect or store any personal information from users (e.g., name, email, phone number). All calendar data accessed via EventKit is only used temporarily to display live activities.</p>

      <h2>5. Contact Us</h2>
      <p>If you have any questions or concerns about these T&Cs or BusyBee, please contact us at:</p>
      <p>
        <strong>Little Apps Ltd</strong><br />
        71-75 Shelton Street, Covent Garden<br />
        London, United Kingdom, WC2H 9JQ<br />
        Email: <a href="mailto:busybeehelp@littleapps.xyz">busybeehelp@littleapps.xyz</a>
      </p>

      <hr />
      <p>By using BusyBee, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.</p>
    </Container>
  );
};

export default Terms; 